import {UserIcon} from './UserIcon'

interface UserDetailProps{
    username?:string;
    isAuthenticated:Boolean;
    signinHandler:()=>void;
    signoutHandler:()=>void;
    userdetailsHandler:()=>void;
   }

   /// Questo componenete renderizza l'insieme degli elementi che descrivono l'utente loggato.
   /// Fornisce inoltre un pulsante per il log-in e un pulsante per il log-out
   export const UserDetail:React.FC<UserDetailProps> = ({username,isAuthenticated,signinHandler,signoutHandler,userdetailsHandler}) =>{


    return(
        <div className="container-fluid">
            <div className="row justify-content-end">
                <div className="col-6 d-none d-l-none d-xl-none d-xxl-block text-end">
                    <div>
                        <span>{username == "" ? "unknown user" : username}</span>
                    </div>
                    <div>
                    { isAuthenticated==false  && <button type="button" className="btn btn-primary btn-sm" onClick={signinHandler}>Sign in</button>}
                    { isAuthenticated==true  &&  <button type="button" className="btn btn-danger btn-sm" onClick={signoutHandler}>Sign Out</button>}
                    </div>
                </div>
                <div className="col col-lg-1 my-auto text-end" >
                    <UserIcon userdetailsHandler={userdetailsHandler}></UserIcon>
                </div>
            </div>
        </div>
    );
   }